import {
  Container,
  InfoSkeleton,
  ButtonContainer,
  EditButtonSkeleton,
  ContinueButtonSkeleton,
} from './styled';

const SummaryLoader = () => (
  <Container>
    <InfoSkeleton />
    <ButtonContainer>
      <EditButtonSkeleton />
      <ContinueButtonSkeleton />
    </ButtonContainer>
  </Container>
);

export default SummaryLoader;
